import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./page/HomePage";
import StillImagesPage from "./page/StillImagesPage";
import VideoPage from "./page/VideoPage";
import ContactPage from "./page/Contact";
import SoulOfMyWorkPage from "./page/SoulOfMyWorkPage";
import SketchOfMyProfilePage from "./page/SketchOfMyProfile";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/still-image-gallery" element={<StillImagesPage />} />
        <Route path="/movable-pieces" element={<VideoPage />} />
        <Route path="/soul-of-my-work" element={<SoulOfMyWorkPage />} />
        <Route path="/sketch-of-my-profile" element={<SketchOfMyProfilePage />} />
        <Route path="/find-myself" element={<ContactPage />} />

       </Routes>
    </Router>
  );
};

export default App;
